// extracted by mini-css-extract-plugin
export default {"wrapper":"EditOrganization_wrapper__IsSk9","form":"EditOrganization_form__Nm2HM"};